// extracted by mini-css-extract-plugin
export var bodyRow = "_cj-d";
export var cardColumns = "_cj-e";
export var ellipsesOverflow = "_cj-2";
export var flatBottomCorners = "_cj-3";
export var flatTopCorners = "_cj-4";
export var headerActionsDropdown = "_cj-f";
export var headerBottomRow = "_cj-c";
export var headerTopRow = "_cj-b";
export var orderDetailsWrapper = "_cj-0";
export var orderInfoContainer = "_cj-1";
export var productDetails = "_cj-9";
export var productImage = "_cj-5";
export var responsiveTable = "_cj-8";
export var shipmentContainer = "_cj-a";
export var tableBottomLeft = "_cj-6";
export var tableBottomRight = "_cj-7";
export var trackingLink = "_cj-g";